import React from "react";
import { useTranslation } from "react-i18next";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import Table from "@mui/material/Table";

const UserScheduledSlots = ({ scheduleSlots }) => {
  const { t } = useTranslation();

  return (
    <>
      <Table sx={{ minWidth: 650 }} aria-label={t("scheduled_slots.table_label")}>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "25%" }}>{t("scheduled_slots.event_type")}</TableCell>
            <TableCell style={{ width: "25%" }}>{t("location")}</TableCell>
            <TableCell style={{ width: "25%" }}>{t("start_date")}</TableCell>
            <TableCell style={{ width: "25%" }}>{t("end_date")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {scheduleSlots.map((row) => (
            <TableRow key={row.id}>
              <TableCell> {row.event_type.charAt(0).toUpperCase() + row.event_type.slice(1)}</TableCell>
              <TableCell> {row.location}</TableCell>
              <TableCell> {row.start_date_text}</TableCell>
              <TableCell> {row.end_date_text}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};

export default UserScheduledSlots;
